var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.bet
    ? _c(
        "div",
        { staticClass: "crash-bet-card", class: _vm.cardClasses },
        [
          _c("div", { staticClass: "user-info" }, [
            _c(
              "a",
              {
                staticClass: "avatar-wrapper",
                attrs: {
                  href: "/profile/" + _vm.bet.userId,
                  "aria-label": "profile",
                },
              },
              [
                _c("img", {
                  staticClass: "avatar-img",
                  attrs: {
                    loading: "lazy",
                    src: _vm.getAvatar(_vm.bet.avatar),
                    alt: "",
                  },
                }),
                _vm.isOwner
                  ? _c("div", { staticClass: "own-tag" }, [
                      _c("span", [_vm._v("我")]),
                    ])
                  : _vm._e(),
              ]
            ),
            _c("div", { staticClass: "user-details" }, [
              _c(
                "div",
                { staticClass: "nickname-box blured-in-streamer-mode" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nickname-link",
                      attrs: { href: "/profile/" + _vm.bet.userId },
                    },
                    [_vm._v(" " + _vm._s(_vm.bet.name) + " ")]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "bet-amount",
                  class: { "text-white": _vm.isWonBig },
                },
                [
                  _c("i", { staticClass: "icon icon_coin-bold" }),
                  _c("span", [_vm._v(_vm._s(_vm.bet.betAmount))]),
                ]
              ),
            ]),
          ]),
          _c("div", { staticClass: "status-info" }, [
            _c(
              "div",
              { staticClass: "crash-bet__ratio", class: _vm.ratioClasses },
              [
                _vm.isOwner || _vm.bet.status !== _vm.BetStatus.IN_GAME
                  ? [
                      _vm.ratio > 0
                        ? [_c("span", [_vm._v(_vm._s(_vm.formattedRatio))])]
                        : [
                            _c("span", { staticClass: "text-manual" }, [
                              _vm._v("自动"),
                            ]),
                          ],
                    ]
                  : [
                      _c("span", { staticClass: "text-ingame" }, [
                        _vm._v("游戏中"),
                      ]),
                    ],
              ],
              2
            ),
            _vm.bet.status === _vm.BetStatus.WON
              ? _c(
                  "div",
                  {
                    staticClass: "win-amount-badge",
                    class: _vm.isWonBig ? "badge-big" : "badge-small",
                  },
                  [
                    _c("i", { staticClass: "icon icon_coin-bold" }),
                    _c("span", [_vm._v(_vm._s(_vm.bet.winningAmount))]),
                  ]
                )
              : _vm._e(),
          ]),
          _vm.bet.status === _vm.BetStatus.IN_GAME
            ? [
                _c("div", { staticClass: "action-spectate" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn-spectate",
                      on: {
                        click: function ($event) {
                          return _vm.setSpectatorBet(_vm.bet.userId)
                        },
                      },
                    },
                    [_c("i", { staticClass: "icon icon_eye" })]
                  ),
                ]),
              ]
            : _vm.bet.status === _vm.BetStatus.WON
            ? [
                _vm.isWonBig
                  ? _c("div", { staticClass: "arrow-container" }, [
                      _c("img", {
                        staticClass: "icon_animation_up arrow-icon",
                        attrs: {
                          loading: "lazy",
                          src: require("../../assets/up.svg"),
                        },
                      }),
                    ])
                  : [
                      _c("img", {
                        staticClass: "text_shadow_animation shadow-bg",
                        attrs: {
                          loading: "lazy",
                          src: require("../../assets/greenShadow.webp"),
                        },
                      }),
                      _c("img", {
                        staticClass: "icon_animation_up arrow-icon",
                        attrs: {
                          loading: "lazy",
                          src: require("../../assets/greenUp.svg"),
                        },
                      }),
                    ],
                _c("img", {
                  staticClass: "won-item-img",
                  attrs: {
                    loading: "lazy",
                    src: _vm.getItemImage(_vm.bet.rewardItem),
                  },
                }),
              ]
            : _vm.bet.status === _vm.BetStatus.LOST
            ? [
                _c("img", {
                  staticClass: "icon_animation_down arrow-icon-down",
                  attrs: {
                    loading: "lazy",
                    src: require("../../assets/down.svg"),
                  },
                }),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }